import { formatDate } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ApiservicesService } from '../../../../apiservices.service';
import { UserTopComponent } from '../../../../components/user-top/user-top.component';
import { EncryptdecryptService } from '../../../../services/encryptdecrypt.service';

@Component({
  providers: [UserTopComponent],
  selector: 'app-profil-firma',
  templateUrl: './profil-firma.component.html',
  styleUrls: ['./profil-firma.component.css']
})
export class ProfilFirmaComponent implements OnInit {

  //Alert Variables
  AlertType: string = "";
  AlertStatus: boolean = false;
  AlertMessage: string = "";

  //Status Variables
  LoaderStatus: any = false;

  //UI View Variables
  FirmNameView: any = "";
  TaxRefNumView: any = "";
  FirmIDView: any = "";
  RegisterDateView: any = "";

  constructor(private apiServices: ApiservicesService, private top: UserTopComponent, private encryptDecryptService: EncryptdecryptService) { }

  ngOnInit(): void {
    this.top.updateTotal();
    this.GetData(this.encryptDecryptService.decrypt(sessionStorage.getItem('FirmID') || ''));
  }

  async GetData(FirmID: any) {
    this.LoaderStatus = true;
    const result = await this.apiServices.GetFirmDetailUsingFirmID(FirmID);
    if (result.body.hasRalat) {
      this.LoaderStatus = false;
      this.AlertType = "fail";
      this.AlertMessage = result.body.ralatMesej;
      this.AlertStatus = true;
      setTimeout(() => {
        this.AlertStatus = false;
      }, 1001);
    } else {
      this.FirmNameView = result.body.namaFirma;
      this.TaxRefNumView = result.body.noCukaiPendapatanFirma;
      this.FirmIDView = result.body.firmID;
      this.RegisterDateView = (result.body.tarikhDaftar === "" || result.body.tarikhDaftar === null) ? "N/A" : formatDate(result.body.tarikhDaftar, 'dd-MMM-yyyy h:mm:ss a', "en-US");
      this.LoaderStatus = false;
    }
  }

}
